$bog_theme_demo $mol_example_large
	plugins /
		<= Theme $bog_theme_auto
	style *
		--mol_theme_hue <= hue_deg \
		--mol_theme_hue_spread <= hue_spread_deg \
	sub /
		<= Config $mol_row sub /
			<= Theme_field $mol_form_field
				name \Theme
				Content <= Theme_select $mol_select
					dictionary <= theme_dictionary *
					value? <=> theme_current? \
					options <= theme_options /string
			<= Theme_toggle $bog_theme_toggle
				theme_auto <= Theme
			<= Hue_field $mol_form_field
				name \Hue
				Content <= Hue $mol_number
					value? <=> hue? 540
					precision_change 15
			<= Hue_spread_field $mol_form_field
				name \Hue spread
				Content <= Hue_spread $mol_number
					value? <=> hue_spread? 90
					precision_change 15
			<= Sat_field $mol_form_field
				name \Bar saturation
				Content <= Sat $mol_number
					value? <=> sat? 80
					precision_change 10
			<= Lig_field $mol_form_field
				name \Bar lightness
				Content <= Lig $mol_number
					value? <=> lig? 60
					precision_change 10
		<= Plot $mol_plot_pane
			hue_base <= hue
			hue_shift <= hue_spread
			graphs <= bars /
				<= Bar* $bog_theme_demo_bar
					series_x <= bar_x* /number
					series_y <= bar_y* /number
					sat <= sat
					lig <= lig
		<= Scroll $mol_scroll sub /
			<= Cases $bog_theme_demo_case
				title \Current light
				inner /
					<= Base $bog_theme_demo_case theme \$mol_theme_base
					<= Current $bog_theme_demo_case theme \$mol_theme_current
					<= Special $bog_theme_demo_case theme \$mol_theme_special
					<= Accent $bog_theme_demo_case theme \$mol_theme_accent
	tags /
		\theme
		\skin
	aspects /
		\Type/Color

$bog_theme_demo_case $mol_view
	title <= theme \
	sub /
		<= Self $mol_list rows /
			<= Card1 $mol_list rows /
				<= Card2 $mol_row sub /
					<= Card2_text $mol_button_copy title <= title
				<= Card1_text $mol_button_copy title \	$mol_theme.card
			<= Back $mol_button_copy title \$mol_theme.back
			<= Line $mol_button_copy title \$mol_theme.line
			<= Text $mol_button_copy title \$mol_theme.text
			<= Field $mol_button_copy title \$mol_theme.field
			<= Shade $mol_button_copy title \$mol_theme.shade
			<= Focus $mol_button_copy title \$mol_theme.focus
			<= Control $mol_button_copy title \$mol_theme.control
			<= Hover $mol_button_copy title \$mol_theme.hover
			<= Current $mol_button_copy title \$mol_theme.curent
			<= Special $mol_button_copy title \$mol_theme.special
		^ inner
	inner /

$bog_theme_demo_bar $mol_plot_bar
	sat? +NaN
	lig? +NaN
